export const getVendorOptions = (builder) => ({
    getVendorOptions: builder.mutation({
        query: () => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: '/get_vendor_drop_down',
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});